import styled from 'styled-components'

export const ProgressRingContainer = styled('div')`
  position: relative;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 10px;
    font-weight: 600;
    transform: translate(-50%, -50%);
    height: 12px;
    width: 18px;
    background-color: #f1f4f9;
    border-radius: 3px;
  }
`

export const ProgressRing = styled('svg')`
  transition: stroke-dashoffset 0.5s ease-in-out; 
  display: block;

  .progress {
    stroke: #f1f4f9; /* Change the color on hover if needed */
  }
`

export const Progress = styled('circle')``

export const RingBackground = styled('circle')``